import { RotateCcw, AlertTriangle } from "lucide-react";
import { PanelSection } from "./PanelSection";
import { DefaultHashtags } from "./StudioDefaultsPanel";

const TITLE_MAX = 100;
const DESC_MAX = 5000;
const inputCls = "w-full bg-white border border-zinc-200 hover:border-zinc-300 rounded-[4px] px-3 py-2.5 text-sm text-zinc-900 outline-none focus:border-rose-500 transition-colors";

const CharCounter = ({ n, max, testId }) => (
  <div data-testid={testId}
    className={`text-right text-xs font-mono ${n >= max ? "text-red-600" : n >= max * 0.9 ? "text-amber-600" : "text-zinc-400"}`}>
    {n.toLocaleString()}/{max.toLocaleString()}
  </div>
);

// Title, description and hashtags sent to YouTube. Shown under the video and in the Publish popup (prefix keeps test ids unique).
export function PublishDetails({ pubTitle, setPubTitle, pubDesc, setPubDesc, prefix = "details", className = "mt-6", fullDescLen = 0, onRefillTitle, ...tagProps }) {
  return (
    <div className={`${className} flex flex-col gap-6`} data-testid={`${prefix}-publish-details`}>
      <PanelSection label="Video Title" testId={`${prefix}-title-section`}>
        <input value={pubTitle} onChange={(e) => setPubTitle(e.target.value)} maxLength={TITLE_MAX}
          data-testid={`${prefix}-title-input`} placeholder="Video title" className={inputCls} />
        <div className="flex items-center justify-between gap-3">
          {onRefillTitle ? (
            <button type="button" onClick={onRefillTitle} data-testid={`${prefix}-title-refill-btn`}
              className="flex items-center gap-1.5 text-xs text-zinc-500 hover:text-rose-600 transition-colors">
              <RotateCcw size={12} /> Use creator's name in title
            </button>
          ) : <span />}
          <CharCounter n={pubTitle.length} max={TITLE_MAX} testId={`${prefix}-title-char-counter`} />
        </div>
      </PanelSection>
      <PanelSection label="Video Description" testId={`${prefix}-desc-section`}>
        <textarea value={pubDesc} onChange={(e) => setPubDesc(e.target.value)} rows={5} maxLength={DESC_MAX}
          data-testid={`${prefix}-desc-input`} placeholder="Video description" className={`${inputCls} resize-y`} />
        <CharCounter n={pubDesc.length} max={DESC_MAX} testId={`${prefix}-desc-char-counter`} />
      </PanelSection>
      <DefaultHashtags prefix={prefix} {...tagProps} />
      {fullDescLen > DESC_MAX && (
        <div data-testid={`${prefix}-desc-limit-warning`} className="flex items-start gap-2 bg-red-50 border border-red-200 text-red-700 text-xs rounded-[4px] px-3 py-2.5">
          <AlertTriangle size={14} className="shrink-0 mt-px" />
          <span>Your description plus hashtags is {fullDescLen.toLocaleString()} characters, over YouTube's {DESC_MAX.toLocaleString()} limit. Remove {(fullDescLen - DESC_MAX).toLocaleString()} character{fullDescLen - DESC_MAX === 1 ? "" : "s"} to publish.</span>
        </div>
      )}
    </div>
  );
}
